import { configReducer } from '../../store/config/config.reducer';
import { indexPageReducer } from '../../store/template/indexPage/indexPage.reducer';
import { TemplateRegistration } from '../templateRegistration';
import {
  GET_PALETTE_DATA,
  INJECT_ACCESSIBILITY_ICON_TO_HEADER,
  INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
  INJECT_BUTTON_TO_MENU,
  INJECT_VIDEO_LOGO,
} from '../../client/clientAPI/events';
import { announcementReducer } from '../../store/announcement/announcement.reducer';
import { footerReducer } from '../../store/navigations/navigation/footer/footer.reducer';
import { headerReducer } from '../../store/navigations/navigation/header/header.reducer';
import { menuReducer } from '../../store/navigations/navigation/menu/menu.reducer';
import { IndexPagePaphosComponent } from './IndexPagePaphosComponent';

const rootReducer = {
  config: configReducer,
  footer: footerReducer,
  header: headerReducer,
  menu: menuReducer,
  template: indexPageReducer,
  siteAnnouncement: announcementReducer,
};


export const IndexPagePaphos = new TemplateRegistration()
  .setComponent(IndexPagePaphosComponent)
  .setRootReducer(rootReducer)
  .addClientAPIEvent(INJECT_VIDEO_LOGO)
  .addClientAPIEvent(INJECT_BUTTON_TO_FOOTER_LINKS_SECTION)
  .addClientAPIEvent(INJECT_BUTTON_TO_MENU)
  .addClientAPIEvent(GET_PALETTE_DATA)
  .addClientAPIEvent(INJECT_ACCESSIBILITY_ICON_TO_HEADER)
  .build();
